export default __webpack_public_path__ + "static/media/icon-Connect-Blogosphere.2e288462.svg";